import { getAPIManagerInstance } from './apiManager';
import {
  DECKARD_API_URL,
  httpMethodFunctions,
  DIGIFIER_API_URL,
} from './common';
import { RootState } from 'src/store/store';

export const fetchDocumentUploadToken = async (
  applicationNumber: string,
  documentType: string,
  apiReqParams = {},
  state: RootState
): Promise<{ uploadToken: string }> => {
  const url = `${DECKARD_API_URL}/${getAPIManagerInstance().getPlaceUrl()}/getUploadTokenXcp/${applicationNumber}`;
  const accessToken = state.auth.idToken;

  const result = await httpMethodFunctions.get<{ uploadToken: string }>(
    url, // URL
    {
      params: {
        document_type: documentType,
        ...apiReqParams,
      },
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );

  return result?.data;
};

export const uploadDocument = async ({
  uploadToken,
  file,
}: {
  uploadToken: string;
  file: File;
}): Promise<unknown> => {
  const uploadUrl = `${DIGIFIER_API_URL}`;

  let retryCount = 0;
  let latestError;

  while (retryCount < 3) {
    try {
      const response = await httpMethodFunctions.post(
        `${uploadUrl}/upload/`, // URL
        file, // Data
        {
          // Config
          params: { upload_token: uploadToken },
          headers: { 'Content-Type': file.type },
        }
      );

      return response;
    } catch (e) {
      retryCount++;
      latestError = e;
    }
  }

  throw latestError;
};
